import avidaLogo from '../../assets/images/companiesLogos/avida.png';
// import balanseBankLogo from '../../assets/images/companiesLogos/balansebank.png';
// import bank2Logo from '../../assets/images/companiesLogos/bank2.svg';
import bankNorwegianLogo from '../../assets/images/companiesLogos/bankNorwegian2024.svg';
import expressBankLogo from '../../assets/images/companiesLogos/express_bank.svg';
import ikanoBankLogo from '../../assets/images/companiesLogos/ikano_bank.svg';
import instabankLogo from '../../assets/images/companiesLogos/instabank.svg';
import kraftBankLogo from '../../assets/images/companiesLogos/kraftbank.svg';
import leaBankLogo from '../../assets/images/companiesLogos/lea.png';
import morrowBankLogo from '../../assets/images/companiesLogos/morrow.svg';
// import myBankLogo from '../../assets/images/companiesLogos/myBank.svg';
import nordaxLogo from '../../assets/images/companiesLogos/nordax.svg';
// import spareBankenLogo from '../../assets/images/companiesLogos/sparebanken.svg';
import nordeaLogo from '../../assets/images/companiesLogos/nordea.svg';
import rememberLogo from '../../assets/images/companiesLogos/remember.svg';
import resursBankLogo from '../../assets/images/companiesLogos/resurs.png';
import santanderLogo from '../../assets/images/companiesLogos/santander.svg';
import sveaLogo from '../../assets/images/companiesLogos/svea.png';
import tfBankLogo from '../../assets/images/companiesLogos/tf_bank.svg';
import yaLogo from '../../assets/images/companiesLogos/yaResurs.png';
import avidaLogoColored from '../../assets/images/companiesLogosColored/avida.png';
import bankNorwegianLogoColored from '../../assets/images/companiesLogosColored/bankNorwegian2024.svg';
import expressBankLogoColored from '../../assets/images/companiesLogosColored/express_bank.svg';
import ikanoBankLogoColored from '../../assets/images/companiesLogosColored/ikano_bank.svg';
import instabankLogoColored from '../../assets/images/companiesLogosColored/instabank.svg';
import morrowBankLogoColored from '../../assets/images/companiesLogosColored/morrow.svg';
import nordaxLogoColored from '../../assets/images/companiesLogosColored/nordax.svg';
import nordeaLogoColored from '../../assets/images/companiesLogosColored/nordea.svg';
import rememberLogoColored from '../../assets/images/companiesLogosColored/remember.svg';
import resursBankLogoColored from '../../assets/images/companiesLogosColored/resurs_bank.svg';
import santanderLogoColored from '../../assets/images/companiesLogosColored/santander.svg';
import sveaLogoColored from '../../assets/images/companiesLogosColored/svea.svg';
import tfBankLogoColored from '../../assets/images/companiesLogosColored/tf_bank.svg';
import yaLogoColored from '../../assets/images/companiesLogosColored/ya.png';

export const BANKS_LOGOS = [
  { key: 'avida', src: [avidaLogo, avidaLogoColored] },
  { key: 'expressbank', src: [expressBankLogo, expressBankLogoColored] },
  { key: 'ikanobank', src: [ikanoBankLogo, ikanoBankLogoColored] },
  { key: 'instabank', src: [instabankLogo, instabankLogoColored] },
  { key: 'morrowbank', src: [morrowBankLogo, morrowBankLogoColored] },
  { key: 'nordax', src: [nordaxLogo, nordaxLogoColored] },
  { key: 'remember', src: [rememberLogo, rememberLogoColored] },
  { key: 'bankNorwegian', src: [bankNorwegianLogo, bankNorwegianLogoColored] },
  { key: 'resursbank', src: [resursBankLogo, resursBankLogoColored] },
  { key: 'santander', src: [santanderLogo, santanderLogoColored] },
  { key: 'svea', src: [sveaLogo, sveaLogoColored] },
  { key: 'lea', src: [leaBankLogo, leaBankLogo] },
  { key: 'tfbank', src: [tfBankLogo, tfBankLogoColored] },
  { key: 'ya', src: [yaLogo, yaLogoColored] },
  { key: 'nordea', src: [nordeaLogo, nordeaLogoColored] },
];
export const BANK_REFIN_LOGOS = [
  { key: 'avida', src: [avidaLogo, avidaLogoColored] },
  // { key: 'expressbank', src: [expressBankLogo, expressBankLogoColored] },
  { key: 'ikanobank', src: [ikanoBankLogo, ikanoBankLogoColored] },
  { key: 'instabank', src: [instabankLogo, instabankLogoColored] },
  { key: 'morrowbank', src: [morrowBankLogo, morrowBankLogoColored] },
  { key: 'nordax', src: [nordaxLogo, nordaxLogoColored] },
  { key: 'remember', src: [rememberLogo, rememberLogoColored] },
  // { key: 'resursbank', src: [resursBankLogo, resursBankLogoColored] },
  { key: 'santander', src: [santanderLogo, santanderLogoColored] },
  { key: 'svea', src: [sveaLogo, sveaLogoColored] },
  { key: 'tfbank', src: [tfBankLogo, tfBankLogoColored] },
  // { key: 'ya', src: [yaLogo, yaLogoColored] },
  { key: 'bankNorwegian', src: [bankNorwegianLogo, bankNorwegianLogoColored] },
  // { key: 'balansebank', src: [balanseBankLogo, balanseBankLogo] },
  // { key: 'bank2', src: [bank2Logo, bank2Logo] },
  { key: 'kraftbank', src: [kraftBankLogo, kraftBankLogo] },
  { key: 'lea', src: [leaBankLogo, leaBankLogo] },
  // { key: 'mybank', src: [myBankLogo, myBankLogo] },
  // { key: 'sparebanken', src: [spareBankenLogo, spareBankenLogo] },
  { key: 'nordea', src: [nordeaLogo, nordeaLogoColored] },
];
